export default function initHoverlink() {
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  document.querySelectorAll('.hover-block-section').forEach(section => {
    const previewElement = section.querySelector('.preview');

    if (!previewElement) {
      console.warn('Preview element is missing.');
      return;
    }

    const initialImageSrc = previewElement.src;

    const preloadImages = () => {
      section.querySelectorAll('.hover-list a').forEach(link => {
        const imageUrl = link.getAttribute('data-image');
        if (imageUrl) {
          const img = new Image();
          img.src = imageUrl;
        }
      });
    };
    preloadImages();

    section.querySelectorAll('.hover-list a').forEach(link => {
      const updatePreview = () => {
        const imageUrl = link.getAttribute('data-image');
        if (imageUrl) {
          previewElement.src = imageUrl;
        }

        const currentActive = section.querySelector('.hover-list a.active');
        if (currentActive && currentActive !== link) {
          currentActive.classList.remove('active');
        }
        link.classList.add('active');
      };

      const resetToInitialState = () => {
        previewElement.src = initialImageSrc;
        const currentActive = section.querySelector('.hover-list a.active');
        if (currentActive) {
          currentActive.classList.remove('active');
        }
      };

      link.addEventListener('mouseenter', () => {
        if (!isTouchDevice) {
          updatePreview();
        }
      });

      link.addEventListener('mouseleave', () => {
        if (!isTouchDevice) {
          resetToInitialState();
        }
      });

      link.addEventListener('touchstart', (e) => {
        e.preventDefault();
        const currentActive = section.querySelector('.hover-list a.active');
        if (link.classList.contains('active')) {
          window.location.href = link.href;
        } else {
          if (currentActive && currentActive !== link) {
            resetToInitialState();
          }
          updatePreview();
        }
      });
    });
  });
}